import type { HomeworkAnswerTraceNode, ProblemBoardAnnotation } from '@wx-weiqi/contracts';

/** The persisted trace, not the playback cursor, records whether answering has begun. */
export function visibleHomeworkInitialAnnotations(
  annotations: readonly ProblemBoardAnnotation[] | undefined,
  sessionReady: boolean,
  traceNodes: readonly HomeworkAnswerTraceNode[],
): readonly ProblemBoardAnnotation[] {
  return sessionReady && !traceNodes.some((node) => node.moves.length > 0)
    ? (annotations ?? [])
    : [];
}
